module.exports = __webpack_public_path__ + "static/media/24.b176b7a6.png";